import React, {useContext, useRef} from 'react';
import { PageContainer, Callout } from './Utilities';
import { VideoContext } from '../context/VideoContext';

import speakerIconOn from '../img/speaker-on.svg';
import speakerIconOff from '../img/speaker-off.svg';

import HelpScreen from './HelpScreen';
import logoLarge from '../img/logo-large.svg';
import Preloader from './Preloader';

// eslint-disable-next-line no-empty-pattern
const Intro = React.forwardRef (({},ref) => {

  return (
    <div id="IntroScreen" ref={ref} className="relative z-[9999999]">

      <PageContainer id="titleScreen" className="min-h-screen">
        <IntroScreen />
      </PageContainer>

      <PageContainer id="helpScreen" className="min-h-screen relative">
        <div className="helpScreenBg w-full h-screen absolute bg-black"></div>
        <HelpScreen />
      </PageContainer>
    </div>
  );
});

export default Intro;

const IntroScreen = () => {

  const { playAudio, setPlayAudio, setCurrentOverlay, isLoading } = useContext(VideoContext);

  const clickAudioRef = useRef(null);

  const clickSpeaker = (e) => {
    e.preventDefault();
    if (playAudio) {
      setPlayAudio(false);
    } else {
      setPlayAudio(true);
      setCurrentOverlay(`intro`);
    }
  };

  return (
    <div className="flex flex-col h-screen md:h-fit text-center m-auto pb-[90px]">

      <div className="w-full md:w-[520px] h-auto m-auto flex-grow mt-28 md:mt-0 md:mb-8">
        <img src={logoLarge} alt="MAC Lung Visualizer" className="introScreenLogo block m-auto" />
      </div>

      {isLoading && <Preloader />}

      <div className={`${isLoading ? "invisible" : "visible"}`}>
        <p className="introScreenCopy w-full md:w-[560px] text-[16px] md:text-[20px] leading-[20px] md:leading-[23px] text-white font-[500] mb-6 md:mb-12 px-4">
          The real impact of MAC lung disease goes deeper than you think. Enter an interactive experience that lets you see the permanent damage MAC can cause and how to stop it.
        </p>

        <Callout href={playAudio ? "/disable-the-audio" : "/enable-the-audio"} border={true} ref={clickAudioRef} onClick={clickSpeaker} className="introScreenCallout mobile:mb-24 cursor-pointer pointer-events-auto">
          <p id="intro-callout" className="mobile:w-4/5 text-center text-[16px] text-white md:text-center w-[260px] m-auto mb-0 md:mb-2 mt-0">
            Get the full experience with audio. Press here to turn on.
          </p>
          <p className="mobile:w-1/5 m-auto mb-0">
            <img src={playAudio ? speakerIconOn : speakerIconOff} alt="" className="block mr-0 mobile:mr-0 m-auto w-[50px]"/>
          </p>
        </Callout>
      </div>
    </div>
  )
};